export const getListOfItemsAsString = (items: string[], lastItemSeparator: string = 'and') => {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0];
    return items.slice(0, -1).join(', ') + ' ' + lastItemSeparator + ' ' + items[items.length - 1];
  };
  